import React from 'react';

export const BrainIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"></path>
    <path d="M14.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"></path>
    <path d="M7 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"></path>
    <path d="M17 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"></path>
    <path d="M12 16.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"></path>
    <path d="M8.5 10.5l2-2.5"></path>
    <path d="M15.5 10.5l-2-2.5"></path>
    <path d="M10.5 15l1.5-3"></path>
    <path d="M13.5 15l-1.5-3"></path>
  </svg>
);

export const SparkleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v18"></path>
    <path d="M18.5 5.5l-13 13"></path>
    <path d="M5.5 5.5l13 13"></path>
    <path d="M3 12h18"></path>
  </svg>
);

export const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18"></path>
    <path d="M18 17V9"></path>
    <path d="M13 17V5"></path>
    <path d="M8 17v-3"></path>
  </svg>
);

export const SyncIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-primary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21.5 2v6h-6"></path>
    <path d="M2.5 12a10 10 0 0 1 18.38-4.58"></path>
    <path d="M2.5 22v-6h6"></path>
    <path d="M21.5 12a10 10 0 0 1-18.38 4.58"></path>
  </svg>
);